<template>
    <x-dialog
        v-model="isOpen"
        :width="width"
        :max-width="maxWidth"
        persistent
        :content-class="contentClass"
    >
        <x-container
            fluid
            :class="{
                'text-xs-left': textLeft,
                'text-xs-center': !textLeft,
            }"
        >
            <x-layout>
                <x-flex xs12>
                    <h2>{{ computedTitle }}</h2>
                    <slot/>
                </x-flex>
            </x-layout>

            <x-layout class="response-actions" justify-space-between>
                <template v-if="confirmation">
                    <x-flex xs6 class="text-xs-left">
                        <x-btn @click="resolveAndClose(false)" small color="tertiary">{{ cancelText }}</x-btn>
                    </x-flex>

                    <x-flex xs6 class="text-xs-right">
                        <x-btn data-test="modal_confirmation_yes" :disabled="actionDisabled" @click="resolveAndClose(true)" small :color="computedActionColor">{{ computedActionText }}</x-btn>
                    </x-flex>
                </template>

                <template v-else>
                    <x-flex class="text-xs-center">
                        <x-btn :disabled="actionDisabled" @click="resolveAndClose" small :color="computedActionColor">{{ computedActionText }}</x-btn>
                    </x-flex>
                </template>
            </x-layout>
        </x-container>
    </x-dialog>
</template>

<script>
    export default {
        name: 'Modal',
        props: {
            title: {
                type: String
            },
            width: {
                type: [String, Number],
                default: 800
            },
            maxWidth: {
                type: [String, Number],
                default: 800
            },
            textLeft: {
                type: Boolean,
                default: false
            },
            confirmation: {
                type: Boolean,
                default: false
            },
            negative: {
                type: Boolean,
                default: false,
            },
            actionText: {
                type: String
            },
            actionDisabled: {
                type: Boolean,
                default: false,
            },
            cancelText: {
                type: String,
                default: 'Cancel'
            },
            contentClass: {
                type: String,
                default: 'dialog-modal'
            },
        },
        data() {
            return {
                isOpen: false,
                resolve: false
            }
        },
        computed: {
            computedTitle() {
                return this.title || (this.confirmation ? 'Are you sure?' : 'Alert');
            },
            computedActionText() {
                return this.actionText || (this.confirmation ? 'Yes' : 'OK');
            },
            computedActionColor() {
                return this.negative ? 'error' : 'primary';
            }
        },
        methods: {
            open() {
                this.isOpen = true;

                return new Promise((resolve) => {
                    this.resolve = resolve
                });
            },
            resolveAndClose(confirmed) {
                if (this.resolve) {
                    this.resolve(confirmed);
                    this.resolve = false;
                }

                this.isOpen = false
            }
        }
    }
</script>

<style lang="scss" scoped>
    .container {
        padding: 40px;

        :deep() {
            p {
                font-size: rem(14px);
                line-height: rem(20px);
                margin-bottom: rem(16px);
            }

            ul {
                font-size: rem(14px);
            }

            p + ul {
                margin-bottom: rem(16px);
            }
        }
    }
</style>
